import type { PontoEquilibrioResponse } from '@triade/contracts';
import { useConsulta } from './base';

/** Janela da MC% media do ponto de equilibrio (meses). Padrao da tela: 3. */
export type JanelaPontoEquilibrio = 1 | 3 | 6 | 12;

/**
 * GET /margens/ponto-equilibrio?meses=1|3|6|12 (so com custo.ver + rateio.ver). A chave leva a empresa (useConsulta).
 * `habilitado` = false nao chama a API (quem nao tem a permissao nao deve receber 403 na tela).
 */
export function usePontoEquilibrio(meses: JanelaPontoEquilibrio, habilitado: boolean) {
  return useConsulta<PontoEquilibrioResponse>(['margens', 'ponto-equilibrio'], '/margens/ponto-equilibrio', {
    query: { meses: String(meses) },
    ativo: habilitado,
  });
}
